import { render } from "./ProgramUpdateGeneral.vue?vue&type=template&id=299faa05"
import script from "./ProgramUpdateGeneral.vue?vue&type=script&lang=js"
export * from "./ProgramUpdateGeneral.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__